var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "focus-trap",
    {
      model: {
        value: _vm.isActive,
        callback: function($$v) {
          _vm.isActive = $$v
        },
        expression: "isActive"
      }
    },
    [
      _c(
        "modal-dialog",
        [
          _c("transition", { attrs: { name: "slide" } }, [
            _vm.open
              ? _c(
                  "div",
                  {
                    staticClass:
                      "locations-sidebar fixed pin-r pin-y bg-white z-20 transition-slow",
                    attrs: { tabindex: "-1" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "locations-sidebar__inner relative px-4 pb-4 sm:px-8 sm:pb-8"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "absolute pin-r pin-t rounded-full border border-grey-light hover:shadow w-10 h-10 leading-none p-0 mr-4 mt-0 text-xl appearance-none text-grey transition focus:text-red hover:text-red",
                            attrs: { type: "button" },
                            on: { click: _vm.close }
                          },
                          [_vm._v("\n            ×\n          ")]
                        ),
                        _vm._v(" "),
                        _c("location-search"),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list-reset" },
                          _vm._l(_vm.posts, function(location, index) {
                            return _c("location", {
                              key: index,
                              attrs: {
                                location: location,
                                closed: _vm.allLocationsClosed
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3848ea8c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3848ea8c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/Locations.vue
// module id = 518
// module chunks = 0